import EdoPerformanceLoans from './EdoPerformanceLoans';

export default EdoPerformanceLoans;
